import { render } from "./Navbar.vue?vue&type=template&id=fe9b094e&scoped=true&bindings={\"shop\":\"data\",\"open\":\"data\",\"scrolled\":\"data\",\"linksBefore\":\"data\",\"linksAfter\":\"data\",\"onScroll\":\"options\",\"onLogo\":\"options\",\"onOffers\":\"options\"}"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"

import "./Navbar.vue?vue&type=style&index=0&id=fe9b094e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-fe9b094e"

export default script